module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-sharp-duotone-light-300.woff2";